import { conversation, conversations, item, items } from './mailListDragUtil.locstring.json';
import loc, { format } from 'owa-localize';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

import { MailListItemPartDragData } from 'owa-mail-types/lib/types/MailListItemPartDragData';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';

const dragHelperStyles = require('../components/MailListDragHelper.scss');

export function getMailListRowDragPreview(dragData: DragData): HTMLElement {
    const mailListRowDragData = dragData as MailListRowDragData;
    const count = mailListRowDragData.rowKeys.length;
    let stringToShow = count <= 1 ? loc(conversation) : loc(conversations);
    switch (mailListRowDragData.tableListViewType) {
        case ReactListViewType.Conversation:
            stringToShow = count <= 1 ? loc(conversation) : loc(conversations);
            break;
        case ReactListViewType.Message:
            stringToShow = count <= 1 ? loc(item) : loc(items);
            break;
    }

    const innerText = format('{0} {1}', count, stringToShow);
    const elem = document.createElement('div');
    elem.className = isBrowserEdge()
        ? dragHelperStyles.dragHelperStyleEdge
        : dragHelperStyles.dragHelperStyleOtherBrowsers;
    elem.innerText = innerText;
    return elem;
}

export function getMailListItemPartDragPreview(dragData: DragData): HTMLElement {
    const mailListItemPartDragData = dragData as MailListItemPartDragData;
    const count = mailListItemPartDragData.itemIds.length;
    const stringToShow = count <= 1 ? loc(item) : loc(items);

    const innerText = format('{0} {1}', count, stringToShow);
    const elem = document.createElement('div');
    elem.className = isBrowserEdge()
        ? dragHelperStyles.dragHelperStyleEdge
        : dragHelperStyles.dragHelperStyleOtherBrowsers;
    elem.innerText = innerText;
    return elem;
}

export const MAIL_ITEM_DRAG_XOFFSET = -12;
export const MAIL_ITEM_DRAG_YOFFSET = 5;
